import { render, staticRenderFns } from "./editWorkList.vue?vue&type=template&id=4b1e95e4&scoped=true"
import script from "./editWorkList.vue?vue&type=script&lang=js"
export * from "./editWorkList.vue?vue&type=script&lang=js"
import style0 from "./editWorkList.vue?vue&type=style&index=0&id=4b1e95e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1e95e4",
  null
  
)

export default component.exports